module.exports = __webpack_public_path__ + "static/img/bannerbg04.420132de.png";